import { noneTenantService } from '@/utils/axios'

const api = {
  noticGetPagedWithCf: '/notice/api/public/siteServer/content/getPagedWithCf',
  noticeGetPaged:'/notice/api/public/siteServer/content/getPaged'
}

// 修改
export function noticGetPagedWithCf(params) {
  return noneTenantService({
    url: api.noticGetPagedWithCf,
    method: 'get',
    params,
  })
}

export function noticeGetPaged(params) {
  return noneTenantService({
    url: api.noticeGetPaged,
    method: 'get',
    params,
  })
}